import PropTypes from 'prop-types'
import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  VStack,
  Text,
  HStack,
  Center,
} from '@chakra-ui/react'
import { formatRut } from '../../../utils/formats/formats'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
export default function ConfirmModal({ isOpen, onClose, data, handleConfirm }) {
  return (
    <Modal size="sm" isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader bgColor="#565656" color="white">
          <Center w="100%">Alerta</Center>
        </ModalHeader>
        <ModalBody>
          <VStack spacing="23px">
            <Text variant="subtitle1" fontWeight="600">
              VERIFICA LA INFORMACIÓN DEL COLABORADOR ANTES DE CONTINUAR
            </Text>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                RUT
              </Text>

              <Text variant="body4" fontWeight="400">
                {formatRut(data?.sRUT)?.formatValue}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Nombre
              </Text>

              <Text variant="body4" fontWeight="400">
                {`${data?.sNombre || ''} ${data?.sApellidoPaterno || ''}`}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Centro de costo
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.CentroCosto || 'Sin Asignar'}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Sucursal
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.Sucursal || 'Sin Asignar'}
              </Text>
            </HStack>
            <HStack justifyContent="space-between" w="100%">
              <Text variant="body4" fontWeight="bold">
                Grupo
              </Text>
              <Text variant="body4" fontWeight="400">
                {data?.sGrupo || 'Sin Asignar'}
              </Text>
            </HStack>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            borderRadius="6px"
            boxShadow="0px 12px 16px rgba(0, 0, 0, 0.25)"
            h="65px"
            onClick={handleConfirm}
          >
            <HStack>
              <Text color="white">CONFIRMAR</Text>{' '}
              <FontAwesomeIcon icon={faArrowRight} />
            </HStack>
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}

ConfirmModal.propTypes = {
  data: PropTypes.shape({
    CentroCosto: PropTypes.string,
    Sucursal: PropTypes.string,
    sApellidoPaterno: PropTypes.string,
    sGrupo: PropTypes.string,
    sNombre: PropTypes.string,
    sRUT: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  handleConfirm: PropTypes.func,
}
